// extracted by mini-css-extract-plugin
module.exports =  {"kpiCard":"kpiCard_moqpIV7m","header":"header_o8RvuWoA","divider":"divider_PVX5_nct","valueRow":"valueRow_XlVF4uVw","trendRow":"trendRow_jZQiM1ZQ"};